<template>
  <div class="Watchstones h-100">
    <ItemTable
      :fields="fields"
      :league="this.$parent.league"
      :getHref="this.getHref"
      category="watchstones"
      :smallScreen="smallScreen"
    ></ItemTable>
  </div>
</template>

<script>
// @ is an alias to /src
import ItemTable from "../components/Simple-ItemTable";
import isMobile from "../mixins/mobileCheck";
export default {
  name: "Watchstones",
  components: { ItemTable },
  mixins: [isMobile],
  props: ["smallScreen"],
  data() {
    return {
      fields: [
        {
          key: "icon",
          sortable: false,
          thStyle: "width: 3em;",
        },
        {
          key: "name",
          sortable: false,
        },
        {
          key: "uses",
          sortable: false,
          tdClass: "text-nowrap, text-right",
          thClass: "text-right",
        },
        {
          key: "change",
          tdClass: "text-nowrap, text-right",
          thClass: "text-right",
        },
        {
          key: "divine",
          sortable: true,
          tdClass: "text-right",
          thClass: "text-right",
        },
        {
          key: "mean",
          sortable: true,
          tdClass: "text-right",
          thClass: "text-right",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    getHref(item) {
      if (item != undefined) {
        return `https://www.pathofexile.com/trade/search/${this.$parent.league}?q=  {"query":{"status":{"option":"online"},"name":"${item.name}","stats":[{"type":"and","filters":[{"id":"explicit.stat_1479533453","disabled":false,"value":{"min":${item.uses},"max":${item.uses}}}],"disabled":false}],"filters":{"type_filters":{"filters":{"category":{"option":"watchstone"}},"disabled":false}}},"sort":{"price":"asc"}}`;
      }
    },
  },
};
</script>

<style lang="scss"></style>
